module.exports = __webpack_public_path__ + "static/media/next.3ef9ef8c.svg";